import * as actions from './actions';

const initialState = {
	connectors: null,
	loading: false,
	error: false,
	errorDetail: null
};

function reducefetchConnectors(state) {
	return {
		...state,
		connectors: null,
		loading: true,
		error: false
	};
}

function reducefetchConnectorsSuccess(state, action) {
	return {
		...state,
		connectors: action.payload,
		loading: false,
		error: false
	};
}

function reducefetchConnectorsError(state, action) {
	return {
		...state,
		connectors: null,
		loading: false,
		error: true,
		errorDetail: action.payload
	};
}

export const connectors = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.FETCH_CONNECTORS:
			return reducefetchConnectors(state);
		case actions.FETCH_CONNECTORS_SUCCESS:
			return reducefetchConnectorsSuccess(state, action);
		case actions.FETCH_CONNECTORS_ERROR:
			return reducefetchConnectorsError(state, action);
		default:
			return state;
	}
};
